/**
 * Whether the sidebar shows the View-as / org-switcher control (M4S-5670,
 * docs/pdlc/cs-view-as-client.md §3).
 *
 * Two audiences, two flags:
 * - Staff View-as (internal, not a hierarchy member, the provider's own test):
 *   `studio-view-as` only. `studio-subsidiary` plays no part, so turning the
 *   client switcher on broadly never gives every staff member View-as.
 * - Everyone else, the client hierarchy switcher: `studio-subsidiary` and at
 *   least one org in scope, exactly the condition it had before.
 *
 * A rollout gate only. It never authorizes anything: `/api/view-as/events`
 * re-checks eligibility and the flag on every start, resume, check and action.
 */

export interface ViewAsControlGateInputs {
    /** `isInternal && !hasSubsidiaryAccess`, as `SubsidiaryFilterProvider` computes it. */
    isInternalMasquerade: boolean;
    hasViewAsFlag: boolean;
    hasSubsidiaryFlag: boolean;
    subsidiaryOrgIds: readonly number[] | null | undefined;
}

export function shouldShowViewAsControl(inputs: ViewAsControlGateInputs): boolean {
    if (inputs.isInternalMasquerade) return inputs.hasViewAsFlag;
    return inputs.hasSubsidiaryFlag && (inputs.subsidiaryOrgIds?.length ?? 0) >= 1;
}
